import {
  PERMISSIONS_MACROS,
  ROLES_REQUEST,
  ROLES_SUCCESS,
  ROLES_FAILURE,
  ROLE_REQUEST,
  ROLE_SUCCESS,
  ROLE_FAILURE,
  ROLE_SAVE_REQUEST,
  ROLE_SAVE_SUCCESS,
  ROLE_UPDATE_REQUEST,
  ROLE_UPDATE_SUCCESS,
  ROLE_DELETE_REQUEST,
  ROLE_DELETE_SUCCESS,
  ROLE_DELETE_FAILURE,
} from './types';

const initialState = {
  list: [],
  permissionsMacros: [],
  loading: false,
  error: false,
  current: null,
  totalCount: 0,
  pageNumber: 0,
  pageSize: 50,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case PERMISSIONS_MACROS:
      return {
        ...state,
        permissionsMacros: action.value,
        loading: 'permissionsMacros',
        error: false,
      };
    case ROLES_REQUEST:
      return {
        ...state,
        list: [],
        loading: 'list',
        error: false,
        current: null,
      };
    case ROLE_REQUEST:
      return { ...state, loading: 'current', error: false, current: null };
    case ROLE_SAVE_REQUEST:
      return { ...state, loading: 'save', error: false };
    case ROLE_UPDATE_REQUEST:
      return { ...state, loading: 'update', error: false };
    case ROLE_DELETE_REQUEST:
      return { ...state, loading: 'delete', error: false };
    case ROLES_FAILURE:
    case ROLE_FAILURE:
    case ROLE_DELETE_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case ROLES_SUCCESS: {
      const {
        result: list,
        result_count: totalCount,
        page_number: pageNumber,
        page_size: pageSize,
      } = action.payload;

      return {
        ...state,
        list,
        totalCount,
        pageNumber,
        pageSize,
        loading: false,
        error: false,
      };
    }
    case ROLE_SUCCESS:
      return {
        ...state,
        current: action.payload,
        loading: false,
        error: false,
      };
    case ROLE_DELETE_SUCCESS:
      return {
        ...state,
        current: null,
        loading: false,
        error: false,
        list: state.list.filter(({ id }) => id !== action.payload.id),
      };
    case ROLE_SAVE_SUCCESS:
    case ROLE_UPDATE_SUCCESS:
      return { ...state, current: null, loading: false, error: false };
    default:
      return state;
  }
}
